import { Permission, Permissions } from '../../common'

export interface UserSettingsModel {
  featureSwitches: string[]
  emailMfaEnabled: boolean | null
}

export interface UserPermissionsModel {
  id: Permissions
  name: string
  permissions: Permission[]
}

export interface MfaConfigurationModel {
  isEmailMfaEnabled: boolean | null
}

// list of existing feature switches
export enum FeatureSwitches {
  plcConfigurationClassicArchitecture = 'plcconfigurationclassicarchitecture',
  downloadProjectFilesFromUranus = 'downloadprojectfilesfromuranus',
  authToolSuperPowers = 'authtoolsuperpowers',
  cSharpFunctionBlocks = 'csharpfunctionblocks'
}
